import DateColumn from '../column-helpers/date/date-component';
import NameColumn from '../column-helpers/name/name-component';
import PathColumn from '../column-helpers/path/path-component';
import ImageTypeIconColumn from '../column-helpers/image_type_icon/image-type-icon-component';
import VendorColumn from '../column-helpers/detected_vendor/detected-vendor-component';
import FileSizeColumn from '../column-helpers/file_size/file-size-component';
import UploadProgressColumn from '../column-helpers/upload_progress/upload-progress-component';
import {IMAGE_TYPES_FILTER, VENDOR_LIST_FILTER} from '../column-helpers/fileConstants';

const getMappedDeviceConstant = (deviceConstant) => {
  const mappedObject = {};
  Object.values(deviceConstant).forEach((el) => {
    mappedObject[el.name] = el.title;
  });

  return mappedObject;
};

export const filesColumnConfig = {
  imageType: {
    label: 'Type',
    type: 'select',
    columnRendererComponent: ImageTypeIconColumn,
    options: getMappedDeviceConstant(IMAGE_TYPES_FILTER),
    width: 45,
    resizable: false,
    groupable: true,
    shown: true,
    priority: 1,
  },
  fileName: {
    label: 'Name',
    type: 'text',
    columnRendererComponent: NameColumn,
    entityColumn: true,
    width: 110,
    shown: true,
    priority: 2,
  },
  pathId: {
    label: 'Path',
    type: 'text',
    columnRendererComponent: PathColumn,
    context: {},
    width: 110,
    shown: false,
    priority: 3,
  },
  vendor: {
    label: 'Vendor',
    type: 'select',
    columnRendererComponent: VendorColumn,
    entityColumn: true,
    options: getMappedDeviceConstant(VENDOR_LIST_FILTER),
    width: 110,
    shown: true,
    priority: 4,
  },
  fileSize: {
    label: 'File Size',
    type: 'text',
    columnRendererComponent: FileSizeColumn,
    entityColumn: true,
    width: 110,
    shown: true,
    priority: 5,
    dataType: 'double',
  },
  checksum: {
    label: 'Checksum',
    width: 240,
    priority: 6,
    dataType: 'double',
    shown: false,
  },
  uploaded: {
    label: 'Upload %',
    type: 'text',
    columnRendererComponent: UploadProgressColumn,
    entityColumn: true,
    width: 110,
    shown: false,
    priority: 7,
  },
  createdBy: {
    label: 'Created By',
    type: 'text',
    updateFromEntity: true,
    width: 110,
    shown: false,
    priority: 8,
  },
  createdOn: {
    label: 'Created On',
    type: 'datetime',
    columnRendererComponent: DateColumn,
    updateFromEntity: true,
    width: 110,
    shown: false,
    priority: 9,
  },
  updatedBy: {
    label: 'Updated By',
    width: 120,
    shown: false,
    priority: 10,
  },
  updatedOn: {
    label: 'Updated On',
    type: 'datetime',
    columnRendererComponent: DateColumn,
    width: 120,
    shown: false,
    priority: 11,
  },
  status: {
    label: 'Status',
    type: 'text',
    width: 110,
    shown: true,
    priority: 12,
  },
};
